import React from "react";
import { useTheme } from "styled-components";

import { Avatar } from "@mui/material";
import { Row } from "react-bootstrap";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

import { League } from "../../models/Leagues";
import { Cast } from "../../models/Cast";
import { colors } from "../../config/colors";
import { imageUrl } from "../../config";

import { CastAnswer } from "../organisms/AnswerChallengeQuestions";
import CastTeam from "./CastTeam";
import WeeklyListAnalytics from "./WeeklyListAnalytics";

interface AnswerQuestionOptionProps {
    player: Cast;
    league?: League;
    answer?: CastAnswer;
    disabled?: boolean;
    onSelect: () => void;
}

const AnswerQuestionOption: React.FC<AnswerQuestionOptionProps> = ({
    player,
    disabled,
    answer,
    onSelect,
    league,
}) => {
    const theme = useTheme();
    const checked = answer?.cast_id === player.id;

    return (
        <div
            className="align-items-center mt-2 p-3"
            style={{
                color: theme.textColor,
                backgroundColor: theme.primary,
                cursor: "pointer",
                border: checked
                    ? `2px solid ${colors.button}`
                    : `2px solid ${theme.border}`,
                borderRadius: 5,
                opacity: disabled ? 0.5 : 1,
            }}
            onClick={onSelect}
        >
            <Row className="align-items-center" noGutters>
                {checked ? (
                    <CheckCircleIcon color="info" />
                ) : (
                    <RadioButtonUncheckedIcon color="inherit" />
                )}
                <Avatar
                    className="mr-2 ml-2"
                    style={{
                        height: 50,
                        width: 50,
                    }}
                    src={`${imageUrl}${player.pic}`}
                />
                <div>
                    <div>
                        {`${player.first_name || ""} ${player.last_name || ""}`}
                    </div>
                    <CastTeam
                        left
                        size={10}
                        team={player.cast?.team ?? player.team}
                        partner={player.cast?.partner ?? player.partner}
                    />
                </div>
            </Row>
            <WeeklyListAnalytics item={player} league={league} question />
        </div>
    );
};

export default AnswerQuestionOption;
